/* eslint-disable */
// 喂食器(Riko) 运行状态翻译配置，由 喂食器.json 物模型自动生成，勿手工修改
export default [
  {
    "key": "BatteryPercentage",
    "name": "电池电量百分比",
    "type": "double",
    "unit": "%"
  },
  {
    "key": "fdPlanStr",
    "name": "喂食计划Str",
    "type": "text",
    "unit": ""
  },
  {
    "key": "defFdCfg",
    "name": "默认出粮设置",
    "type": "struct",
    "fields": [
      {
        "key": "food",
        "name": "粮重",
        "type": "float",
        "unit": "g"
      },
      {
        "key": "water",
        "name": "水重",
        "type": "float",
        "unit": "g"
      },
      {
        "key": "mixMin",
        "name": "复水时间",
        "type": "int",
        "unit": "min"
      }
    ]
  },
  {
    "key": "weightUnit",
    "name": "猫粮和水的显示单位",
    "type": "enum",
    "map": {
      "0": "g",
      "1": "lb"
    }
  },
  {
    "key": "DND_Mode",
    "name": "勿扰模式",
    "type": "struct",
    "fields": [
      {
        "key": "active",
        "name": "开关",
        "type": "enum",
        "map": {
          "0": "关",
          "1": "开"
        }
      },
      {
        "key": "startTime",
        "name": "开始时间",
        "type": "int",
        "unit": ""
      },
      {
        "key": "endTime",
        "name": "结束时间",
        "type": "int",
        "unit": ""
      },
      {
        "key": "weekRept",
        "name": "周重复",
        "type": "int",
        "unit": ""
      },
      {
        "key": "bAudioDND",
        "name": "音频免打扰",
        "type": "enum",
        "map": {
          "0": "关闭",
          "1": "打开"
        }
      },
      {
        "key": "bDisplayDND",
        "name": "显示屏免打扰",
        "type": "enum",
        "map": {
          "0": "关闭",
          "1": "打开"
        }
      }
    ]
  },
  {
    "key": "lastWaterBinCleanTime",
    "name": "最后水箱清洗时间",
    "type": "text",
    "unit": ""
  },
  {
    "key": "lastFoodBinCleanTime",
    "name": "最后粮仓清洗时间",
    "type": "text",
    "unit": ""
  },
  {
    "key": "showDisplayAtIdle",
    "name": "待机时显示屏显",
    "type": "enum",
    "map": {
      "0": "关",
      "1": "开"
    }
  },
  {
    "key": "waterLvl",
    "name": "水箱水位",
    "type": "enum",
    "map": {
      "0": "水位空",
      "1": "水位缺",
      "2": "水位低",
      "3": "水位中",
      "4": "水位满"
    }
  },
  {
    "key": "foodLvl",
    "name": "粮仓状态",
    "type": "enum",
    "map": {
      "0": "粮空",
      "1": "粮缺",
      "2": "粮足"
    }
  },
  {
    "key": "DeviceVer",
    "name": "机器版本",
    "type": "struct",
    "fields": [
      {
        "key": "FW_Version",
        "name": "固件版本",
        "type": "text",
        "unit": ""
      },
      {
        "key": "HW_Version",
        "name": "硬件版本",
        "type": "text",
        "unit": ""
      },
      {
        "key": "type",
        "name": "机器类型",
        "type": "enum",
        "map": {
          "0": "正常版本"
        }
      },
      {
        "key": "bRegionLock",
        "name": "区域锁状态",
        "type": "enum",
        "map": {
          "0": "无锁",
          "1": "上锁"
        }
      }
    ]
  },
  {
    "key": "childLockOnOff",
    "name": "童锁",
    "type": "enum",
    "map": {
      "0": "关闭",
      "1": "打开"
    }
  },
  {
    "key": "NetWorkStatus",
    "name": "网络状态",
    "type": "struct",
    "fields": [
      {
        "key": "MAC_Addr",
        "name": "MAC地址",
        "type": "text",
        "unit": ""
      },
      {
        "key": "IP_Addr",
        "name": "IP地址",
        "type": "text",
        "unit": ""
      },
      {
        "key": "WiFi_RSSI",
        "name": "信号强度",
        "type": "int",
        "unit": ""
      },
      {
        "key": "WiFi_Name",
        "name": "WiFi名称",
        "type": "text",
        "unit": ""
      }
    ]
  },
  {
    "key": "timeZoneMsg",
    "name": "时区信息",
    "type": "struct",
    "fields": [
      {
        "key": "timeZoneID",
        "name": "时区ID",
        "type": "text",
        "unit": ""
      },
      {
        "key": "zone",
        "name": "时区",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dst",
        "name": "夏令时",
        "type": "enum",
        "map": {
          "0": "夏令时关闭",
          "1": "夏令时开启"
        }
      },
      {
        "key": "dstStartTimeOne",
        "name": "夏令时第一段开启时间戳",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dstEndTimeOne",
        "name": "夏令时第一段停止时间戳",
        "type": "int",
        "unit": ""
      },
      {
        "key": "year",
        "name": "年份",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dstStartTimeTwo",
        "name": "夏令时第二段开始时间戳",
        "type": "int",
        "unit": ""
      },
      {
        "key": "dstEndTimeTwo",
        "name": "夏令时第二段结束时间戳",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "regionBaseurl",
    "name": "后端下发的设备区域服地址",
    "type": "text",
    "unit": ""
  },
  {
    "key": "timestamp",
    "name": "后端下发的时间戳",
    "type": "date",
    "unit": ""
  },
  {
    "key": "bRegionLock",
    "name": "区域锁",
    "type": "enum",
    "map": {
      "0": "无锁",
      "1": "锁区"
    }
  },
  {
    "key": "region",
    "name": "设备所在的区域",
    "type": "text",
    "unit": ""
  },
  {
    "key": "userOpenId",
    "name": "用户的阿里openId",
    "type": "text",
    "unit": ""
  },
  {
    "key": "GenHighSvcEnv",
    "name": "服务器环境",
    "type": "enum",
    "map": {
      "0": "正式环境",
      "1": "测试环境"
    }
  },
  {
    "key": "leftover",
    "name": "剩餐检测",
    "type": "struct",
    "fields": [
      {
        "key": "bOnOff",
        "name": "开关",
        "type": "enum",
        "map": {
          "0": "关",
          "1": "开"
        }
      },
      {
        "key": "detGramTTh",
        "name": "检测阈值",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "deviceState",
    "name": "设备状态",
    "type": "struct",
    "fields": [
      {
        "key": "state",
        "name": "状态",
        "type": "enum",
        "map": {
          "0": "空闲中",
          "1": "备餐中",
          "2": "出餐中",
          "3": "挂起中",
          "4": "故障中"
        }
      },
      {
        "key": "param",
        "name": "参数",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "pwrStatus",
    "name": "电源状态",
    "type": "struct",
    "fields": [
      {
        "key": "pwrType",
        "name": "当前电源",
        "type": "enum",
        "map": {
          "0": "DC供电",
          "1": "电池供电"
        }
      },
      {
        "key": "batStatus",
        "name": "电池状态",
        "type": "enum",
        "map": {
          "0": "不在位",
          "1": "充电中",
          "2": "已充满"
        }
      },
      {
        "key": "batMsg",
        "name": "电池信息",
        "type": "enum",
        "map": {
          "0": "供应商1",
          "1": "供应商2"
        }
      },
      {
        "key": "batPercentage",
        "name": "电池电量",
        "type": "int",
        "unit": "%"
      },
      {
        "key": "batVoltage",
        "name": "电池电压",
        "type": "int",
        "unit": "mV"
      },
      {
        "key": "batLevel",
        "name": "电量等级",
        "type": "enum",
        "map": {
          "0": "紧急",
          "1": "不足",
          "2": "良好",
          "3": "充足"
        }
      },
      {
        "key": "batTemp",
        "name": "电池温度",
        "type": "float",
        "unit": "°C"
      }
    ]
  },
  {
    "key": "leftDrierDays",
    "name": "干燥剂剩余天数",
    "type": "int",
    "unit": ""
  },
  {
    "key": "bCoverAbsent",
    "name": "粮仓盖子是否在位",
    "type": "enum",
    "map": {
      "0": "不在位",
      "1": "在位"
    }
  },
  {
    "key": "disconn",
    "name": "断线记录",
    "type": "struct",
    "fields": [
      {
        "key": "disconnReason",
        "name": "断连原因",
        "type": "int",
        "unit": ""
      },
      {
        "key": "reconnFailed",
        "name": "重连失败原因",
        "type": "int",
        "unit": ""
      },
      {
        "key": "ts",
        "name": "掉线时间",
        "type": "text",
        "unit": ""
      },
      {
        "key": "lockCnt",
        "name": "异常上下线计数",
        "type": "int",
        "unit": ""
      },
      {
        "key": "rssi",
        "name": "掉线前rssi",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "drierResetTs",
    "name": "干燥剂重置时间",
    "type": "text",
    "unit": ""
  },
  {
    "key": "drierEffeDays",
    "name": "干燥剂有效天数",
    "type": "int",
    "unit": ""
  },
  {
    "key": "pwrMode",
    "name": "电源模式",
    "type": "enum",
    "map": {
      "0": "DC模式",
      "1": "电池模式"
    }
  },
  {
    "key": "displayCfg",
    "name": "显示屏设置",
    "type": "struct",
    "fields": [
      {
        "key": "displayType",
        "name": "显示类型",
        "type": "enum",
        "map": {
          "0": "时间",
          "1": "图形",
          "2": "自定义"
        }
      },
      {
        "key": "displayParam",
        "name": "显示参数",
        "type": "text",
        "unit": ""
      },
      {
        "key": "bDisplayIfIdle",
        "name": "空闲时显示",
        "type": "enum",
        "map": {
          "0": "不显示",
          "1": "显示"
        }
      }
    ]
  },
  {
    "key": "smartPlanCfg",
    "name": "智能喂食计划的配置",
    "type": "struct",
    "fields": [
      {
        "key": "catId",
        "name": "猫咪的ID",
        "type": "int",
        "unit": ""
      },
      {
        "key": "drierFoodId",
        "name": "干粮品牌的ID",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "is12HourFormat",
    "name": "是否12小时制",
    "type": "enum",
    "map": {
      "0": "否",
      "1": "是"
    }
  },
  {
    "key": "bowlStatus",
    "name": "粮碗状态",
    "type": "struct",
    "fields": [
      {
        "key": "bBowlIn",
        "name": "粮碗",
        "type": "enum",
        "map": {
          "0": "不在位",
          "1": "在位"
        }
      },
      {
        "key": "bowlGram",
        "name": "粮碗重量",
        "type": "int",
        "unit": ""
      },
      {
        "key": "curWeight",
        "name": "当前重量",
        "type": "int",
        "unit": ""
      }
    ]
  },
  {
    "key": "newbieProgress",
    "name": "新手引导进度",
    "type": "text",
    "unit": ""
  },
  {
    "key": "freshMgrCfg",
    "name": "新鲜度管理配置",
    "type": "struct",
    "fields": [
      {
        "key": "bOnOff",
        "name": "开关",
        "type": "enum",
        "map": {
          "0": "关闭",
          "1": "打开"
        }
      },
      {
        "key": "leftOverTTH",
        "name": "余粮阈值",
        "type": "int",
        "unit": "g"
      },
      {
        "key": "monitorTime",
        "name": "观察时长",
        "type": "int",
        "unit": "h"
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/js/feederRunStateConfig.js